import React from "react";

const ProfileSettings = () => {
  return <div>ProfileSettings</div>;
};

export default ProfileSettings;
